import { forwardRef } from 'react';
import DallasSvgIcon, { Props } from '~/app/_ui/Dallas/Icons/DallasSvgIcon';

const DallasSvgIconRadioButtonUncheckedOutlined = forwardRef<
  SVGSVGElement,
  Props
>(function DallasSvgIconRadioButtonUncheckedOutlined(props: Props, ref) {
  return (
    <DallasSvgIcon {...props} ref={ref}>
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
        fill="currentColor"
      />
    </DallasSvgIcon>
  );
});

export default DallasSvgIconRadioButtonUncheckedOutlined;
